function NewsMoreComment() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="50"
      height="50"
      viewBox="0 0 50 50"
      aria-label="소식 댓글 더보기"
    >
      <desc>소식 댓글 더보기</desc>
      <defs>
        <filter
          id="uetzawpmza"
          width="50"
          height="50"
          x="0"
          y="0"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dy="2"></feOffset>
          <feGaussianBlur result="blur" stdDeviation="3"></feGaussianBlur>
          <feFlood floodOpacity="0.161"></feFlood>
          <feComposite in2="blur" operator="in"></feComposite>
          <feComposite in="SourceGraphic"></feComposite>
        </filter>
      </defs>
      <g data-name="그룹 11032">
        <g filter="url(#uetzawpmza)">
          <g
            fill="#fff"
            stroke="#999"
            data-name="타원 1043"
            transform="translate(9 7)"
          >
            <circle cx="16" cy="16" r="16" stroke="none"></circle>
            <circle cx="16" cy="16" r="15.5" fill="none"></circle>
          </g>
        </g>
        <g
          fill="#999"
          stroke="#999"
          strokeLinecap="round"
          strokeWidth="1.5"
          data-name="사각형 8732"
          transform="rotate(90 4.968 20.968)"
        >
          <rect width="14" height="1.5" stroke="none" rx="0.75"></rect>
          <rect width="12.5" x="0.75" y="0.75" fill="none"></rect>
        </g>
        <g
          fill="#999"
          stroke="#999"
          strokeLinecap="round"
          strokeWidth="1.5"
          data-name="사각형 8733"
          transform="rotate(180 16 11.875)"
        >
          <rect width="14" height="1.5" stroke="none" rx="0.75"></rect>
          <rect width="12.5" x="0.75" y="0.75" fill="none"></rect>
        </g>
      </g>
    </svg>
  )
}

export default NewsMoreComment
